'use client'

import { useCallback, useState } from 'react'

import { CreditTopUpDialog } from '@/components/billing/credit-top-up-dialog'

/**
 * One-time credit pack purchase for the tool studios.
 *
 * Plans with no subscription above them (AppSumo lifetime tiers) recover from
 * an empty balance by buying credits, not by opening the plan grid. The caller
 * passes the workspace-scoped top-up return address (`topUpReturn`), which
 * carries no `upgrade` outcome, so checkout comes back to the studio and is
 * confirmed by `ToolCreditTopUpReturn` rather than announced as an upgrade.
 */
export function useToolCreditTopUp(
  returnUrls: { successUrl: string; cancelUrl: string } | undefined,
) {
  const [open, setOpen] = useState(false)
  const openTopUp = useCallback(() => setOpen(true), [])
  const topUpDialog = open ? (
    <CreditTopUpDialog open onOpenChange={setOpen} returnUrls={returnUrls} />
  ) : null
  return { openTopUp, topUpDialog }
}
